import {
  Lesson,
  ResponseArticle,
  ResponseLessonItem,
  ResponseExercise,
  ResponseVideo,
} from '@/models/undergrad/services/disciplines-reader.model';
import {
  Article,
  LessonItemType,
  Exercise,
  LessonItem as UndergradContent,
  UndergradLesson,
  Video,
} from '@/models/undergrad/undegrad-lesson.model';
import { schema } from 'normalizr';

export const undergradLives = new schema.Entity('undergradLives');

export const undergradCourse = new schema.Entity('undergradCourses');

export const undergradSubmodules = new schema.Entity('undergradSubmodules');

export const undergradContents = new schema.Entity('undergradContents');

export const undergradLessons = new schema.Entity<UndergradLesson>(
  'undergradLessons',
  {},
  {
    processStrategy: (lesson: Lesson) => {
      const contents: UndergradContent[] = [];

      lesson.items?.forEach((item: ResponseLessonItem) => {
        switch (item.typename) {
          case LessonItemType.EXERCISE: {
            const exerciseContent = item as ResponseExercise;
            const exercise = new Exercise();

            exercise.id = exerciseContent.id;
            exercise.lessonItemType = LessonItemType.EXERCISE;
            exercise.type = exerciseContent.exerciseType;
            exercise.name = exerciseContent.name;
            exercise.dexExerciseId = exerciseContent.dexExerciseId;

            contents.push(exercise);
            break;
          }
          case LessonItemType.ARTICLE: {
            const articleContent = item as ResponseArticle;
            const article = new Article();
            article.id = articleContent.id;
            article.lessonItemType = LessonItemType.ARTICLE;
            article.name = articleContent.title;
            article.dexArticleId = articleContent.dexArticleId;

            contents.push(article);
            break;
          }
          case LessonItemType.VIDEO: {
            const videoContent = item as ResponseVideo;
            const video = new Video();
            video.id = videoContent.id;
            video.lessonItemType = LessonItemType.VIDEO;
            video.name = videoContent.videoName;
            video.youtubeId = videoContent.youtubeId;
            video.kalturaId = videoContent.kalturaId;
            video.durationInSeconds = videoContent.actualDurationInSeconds;

            contents.push(video);
            break;
          }
          default:
        }
      });

      return { ...lesson, items: contents };
    },
  },
);

export const undergradDisciplines = new schema.Entity(
  'undergradDisciplines',
  {
    lessons: [undergradLessons],
  },
  {
    idAttribute: (value) => value.id,
  },
);

export const undergradCycles = new schema.Entity('undergradCycles');
